
import { motion } from 'framer-motion';

const ProgramBenefits = () => {
  const benefits = [
    {
      title: 'Expert Mentorship',
      description: 'One-on-one guidance from seasoned PMO leaders with 15+ years of enterprise experience.',
      icon: 'ri-user-heart-line',
    },
    {
      title: 'Real-World Frameworks',
      description: 'Proven methodologies, templates, and tools used in government and corporate environments.',
      icon: 'ri-file-text-line',
    },
    {
      title: 'Career Strategy',
      description: 'Personalized career planning, resume optimization, and interview preparation support.',
      icon: 'ri-roadmap-line',
    },
    {
      title: 'Leadership Development',
      description: 'Build confidence in stakeholder management, team leadership, and executive communication.',
      icon: 'ri-team-line',
    },
    {
      title: 'Tool Mastery',
      description: 'Hands-on training in Smartsheet, Jira, Confluence, and other industry-standard platforms.',
      icon: 'ri-tools-fill',
    },
    {
      title: 'Community Access',
      description: 'Join a network of ambitious PMs, share experiences, and build lasting professional relationships.',
      icon: 'ri-group-line',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-warm-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-inter text-xs uppercase tracking-widest text-taupe mb-4">
            Program Benefits
          </p>
          <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-charcoal mb-6">
            Everything You Need to <em className="text-warm-gold">Excel</em>
          </h2>
          <p className="font-inter text-lg text-charcoal/60 max-w-3xl mx-auto">
            PM Launchpad provides comprehensive support to help you master project management fundamentals and advance your career with confidence.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-warm-gold/20 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-warm-gold/30 transition-colors duration-300">
                  <i className={`${benefit.icon} text-xl text-warm-gold`}></i>
                </div>
                <div>
                  <h3 className="font-inter text-lg font-bold text-charcoal mb-2">
                    {benefit.title}
                  </h3>
                  <p className="font-inter text-base text-charcoal/70 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramBenefits;
